import { VerifyIdentityUseCase } from './VerifyIdentityUseCase'

export const verifyIdentityUseCase = new VerifyIdentityUseCase({}).execute
